import dayjs from "dayjs";
import { UploadType } from "../../../pages";
import { axiosInstance } from "../axios";
import { ConversionHistory, RequestResponse, User } from "../types";

const adaptHistoryRecord = (record: any, fromBackend?: boolean) => {
  if (!record) {
    return record;
  }
  const keyMap: Record<keyof ConversionHistory, string> = {
    key: "id",
    organization: "domain_code",
    date: "transaction_date",
    userName: "userName",
    transId: "transId",
  };

  const dateKey = fromBackend ? "transaction_date" : "date";

  const processedRecord = {
    ...record,
    [dateKey]: fromBackend ? dayjs(record[dateKey]) : record[dateKey].format(),
  };

  const adaptedRecord = Object.entries(keyMap).reduce((map, arr) => {
    const value = processedRecord[fromBackend ? arr[1] : arr[0]];
    return value === undefined
      ? map
      : {
          ...map,
          [fromBackend ? arr[0] : arr[1]]: value,
        };
  }, {});

  return adaptedRecord;
};

export interface RequestHistoryParams {
  pageNumber: number;
  pageSize: number;
  searchStr?: string;
  institutionFilter?: string;
  user: User;
}
interface RequestHistoryPayload {
  history: ConversionHistory[];
  count: number;
}
export const getRequestHistory: (
  params: RequestHistoryParams
) => Promise<RequestResponse<RequestHistoryPayload>> = async (params) => {
  try {
    const { pageNumber, pageSize, searchStr, user, institutionFilter } = params;
    const paramsStr = `page=${pageNumber}&size=${pageSize}`;
    const payload =
      searchStr || institutionFilter
        ? {
            username: searchStr || null,
            filter: institutionFilter || null,
          }
        : undefined;
    const response = await axiosInstance.post(
      `/batch/${
        user.userType === "ISW_ADMIN" ? "isw" : "user"
      }/request-history?${paramsStr}`,
      payload,
      {
        headers: {
          "X-Interswitch-Authorization-Domain": user.domainCode,
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data: {
        history: response.data.dataSet.map((record: any) =>
          adaptHistoryRecord(record, true)
        ),
        count: response.data.totalItems,
      },
    };
  } catch (error) {
    console.error(
      "Unable to get request history: ",
      error.response?.data || error.message
    );
    return {
      error: true,
      data: null,
      message:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

export const reDownloadFile: (
  key: number,
  user: User
) => Promise<RequestResponse> = async (key, user) => {
  try {
    const response = await axiosInstance.post(
      `/batch/user/download-file/${key}`,
      {},
      {
        headers: {
          "X-Interswitch-Authorization-Domain": user.domainCode,
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data: response.data,
      error: false,
    };
  } catch (error) {
    return {
      error: true,
      message:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      data: null,
    };
  }
};

export interface UploadCSVParams {
  file: File;
  // email: string;
  user: User;
  type: string; // Ensuring uploadType is a single string
}

export const uploadCSV: (
  params: UploadCSVParams
) => Promise<RequestResponse> = async ({ file, user, type }) => {
  if (type.includes(",")) {
    return {
      error: true,
      message:
        "Upload type must be a single string, not a comma-separated list.",
      data: null,
    };
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const queryParams = new URLSearchParams({
      type,
      username: user.username,
      // email,
    }).toString();

    const response = await axiosInstance.post(
      `/batch/acquirer-files?${queryParams}`,
      formData,
      {
        headers: {
          "X-Interswitch-Authorization-Domain": user.domainCode,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      data: response.data,
      error: false,
    };
  } catch (error) {
    return {
      error: true,
      message:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      data: null,
    };
  }
};
